import { AccountFieldEnricher } from './accountFieldEnricher';
import { ConfigurationEnricher } from './model';
import { SdkProcessorV1ConfigurationEnricher } from './sdkProcessorV1ConfigurationEnricher';
import { SpecificItemEnricher } from './specificItemEnricher';
import { TokenizerV1ConfigurationEnricher } from './tokenizerV1ConfiguratiomEnricher';

export const GeneralConfigurationEnricher: ConfigurationEnricher = {
  shouldEnrich: (_, __) => true,
  enrich: (configuration, context) => {
    const enrichers: ConfigurationEnricher[] = [
      AccountFieldEnricher,
      TokenizerV1ConfigurationEnricher,
      SdkProcessorV1ConfigurationEnricher,
      SpecificItemEnricher,
    ];

    enrichers.forEach((enricher) => {
      if (enricher.shouldEnrich(configuration, context)) {
        enricher.enrich(configuration, context);
      }
    });
  },
};
